export default __webpack_public_path__ + "static/media/wall-prat-1.42d3cd64.JPG";